import Interface from "../Interface";
import EventManager from "./EventManager";

let eventEM = new EventManager();

const myFunc= function(callback,parameters,isPrevent,event) {
  if(isPrevent) {
    event.preventDefault();
    event.stopPropagation();
  }
  if(Interface.isNull(parameters)){
    callback(event);
  }else{
    callback(event,...parameters);
  }
  return (!isPrevent);
};

const myFuncKey=function(callback,parameters,isPrevent,event) {
  if (event.keyCode  === 27) {
    myFunc(callback,parameters,isPrevent,event);
  }
};

const Escape  = {

  set(el,callback,parameters=[],isPrevent=true) {
    if(Interface.isFunction(callback)) {
      let f2 = myFuncKey.bind(null, callback,parameters,isPrevent);
      eventEM.bind(el, 'keyup',f2 );
    }
  },

  unBind(el){
    eventEM.unbind(el,'keyup',null);
  },
}

export default Escape;
